export const formatItems = (data) => {
  data.orderGuideItems.forEach(item => {
    item.order = '';
    item.lineNote = item.lineNote ? item.lineNote : '';
  });

  return data.orderGuideItems;
};
